var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "filter_block" }, [
    _c("div", { staticClass: "form-group js-stools-container-filters mb-4" }, [
      _c(
        "div",
        { staticClass: "d-flex flex-wrap" },
        [
          _c(
            "div",
            { staticClass: "flex-fill mt-2 mb-2 pr-4" },
            [
              _vm.is_load
                ? _c(
                    "div",
                    { staticClass: "load_select color-primary" },
                    [
                      _c("sync-loader", {
                        attrs: { loading: true, color: "#53644B", size: "5px" },
                      }),
                    ],
                    1
                  )
                : _c(
                    "v-select",
                    {
                      staticClass: "imc_reasons",
                      attrs: {
                        label: "name",
                        placeholder: " Оберіть Організацію",
                        id: "id",
                        reduce: (item) => item.id,
                        options: _vm.organizations,
                        filterable: true,
                      },
                      on: { input: _vm.emit_filter },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function (option) {
                            return [
                              _c("div", { staticClass: "d-center" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(option.name) +
                                    "\n                            "
                                ),
                                _c("small", [_vm._v(_vm._s(option.edrpou))]),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.org_id,
                        callback: function ($$v) {
                          _vm.org_id = $$v
                        },
                        expression: "org_id",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n                        Оберіть Організацію\n                    "
                        ),
                      ]),
                    ],
                    2
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-fill mt-2 mb-2 pr-4" },
            [
              _vm.is_load
                ? _c(
                    "div",
                    { staticClass: "load_select color-primary" },
                    [
                      _c("sync-loader", {
                        attrs: { loading: true, color: "#53644B", size: "5px" },
                      }),
                    ],
                    1
                  )
                : _c(
                    "v-select",
                    {
                      staticClass: "imc_reasons",
                      attrs: {
                        label: "name",
                        id: "id",
                        reduce: (item) => item.id,
                        options: _vm.users,
                        filterable: true,
                        placeholder: "Оберіть Користувача",
                      },
                      on: { input: _vm.emit_filter },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function (option) {
                            return [
                              _c("div", { staticClass: "d-center" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(option.name) +
                                    "\n                        "
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.user_id,
                        callback: function ($$v) {
                          _vm.user_id = $$v
                        },
                        expression: "user_id",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n                        Оберіть Користувача\n                    "
                        ),
                      ]),
                    ],
                    2
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c("vacation_modal"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }